export function generateInvoiceNumber(prefix = "S") {
    const now = new Date();
  
    const datePart = now.toISOString().slice(0, 10).replace(/-/g, "");
    const timePart = now
      .toTimeString()
      .slice(0, 8)
      .replace(/:/g, "");
  
    const randomPart = Math.random()
      .toString(36)
      .substring(2, 6)
      .toUpperCase();
  
    return `${prefix}-${datePart}-${timePart}-${randomPart}`;
  }
  